export default __webpack_public_path__ + "static/media/dr-chisom-amadi.c9641c5a.png";